import Vue from 'vue'
import VueRouter from 'vue-router'   // 引入router
import wechatAuth from '../uilt/wechatAuth' //微信登录插件
const queryString = require('query-string');
import {loginByWechat} from "@/apis/model/user";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect:'home'
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/home/home.vue')
  },
  {
    path: '/report',
    name: 'report',
    component: () => import('../views/report/report.vue')
  },
  {
    path: '/money',
    name: 'money',
    component: () => import('../views/money/money.vue')
  },
  {
    path: '/user',
    name: 'user',
    component: () => import('../views/user/user.vue'),
    props: true
  },
  {
    path: '/userReportList',
    name: 'userReportList',
    component: () => import('../views/user/userReportList.vue')
  },
  {
    path: '/reportInfo/:reportId',
    name: 'reportInfo',
    component: () => import('../views/user/reportInfo.vue')
  },
  {
    path: '/userTaskList',
    name: 'userTaskList',
    component: () => import('../views/user/userTaskList.vue'),
    props: true
  },
  {
    path: '/upuser',
    name: 'upuser',
    component: () => import('../views/user/upuser.vue'),
    props: true
  },
  {
    path: '/userprofit',
    name: 'userprofit',
    component: () => import('../views/user/userprofit.vue'),
    props: true
  },
  {
    path: '/userTaskLogList/:taskId',
    name: 'userTaskLogList',
    component: () => import('../views/user/userTaskLogList.vue'),
    props: true
  },
  {
    path: '/taskreport/:taskId',
    name: 'taskreport',
    component: () => import('../views/user/taskreport.vue'),
    props: true
  },
  {
    path: '/taskReportDetail/:taskLogId',
    name: 'taskReportDetail',
    component: () => import('../views/user/taskReportDetail.vue'),
    props: true
  },
  {
    path: '/infonews/:infoId',
    name: 'infonews',
    component: () => import('../views/home/infonews.vue'),
    props: true
  },
  
  
]

const originalPush = VueRouter.prototype.push;
 
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

function processUrl() {
  const url = window.location.href
  const urlParams = queryString.parse(url.split('?')[1])
  let redirectUrl = url
  if (urlParams.code && urlParams.state) {
    delete urlParams.code
    delete urlParams.state
    const query = queryString.stringify(urlParams)
    if (query.length) {
      redirectUrl = `${url.split('?')[0]}?${query}`
    } else {
      redirectUrl = `${url.split('?')[0]}`
    }
  }
  return redirectUrl
}

/**
 * 微信登录
 * @param {*} code 
 * @returns 
 */
function processLogin(code) {
  const data = {
    code
  };
  return new Promise(async (resolve, reject) => {
    try {
      await loginByWechat({ 'code': code }).then(res => {
        console.info("===req==" + res.data)
        if(res.code==200){
          localStorage.setItem('token', res.data);
          global.token = res.data.token
        }
      });
      sessionStorage.setItem('LOGIN_STATUS', 2);
      resolve({
        status: 1,
        data: '登录成功'
      })
    } catch (err) {
      reject(err)
    }
  })
}

router.beforeEach(async (to, from, next) => {
  if (!global.token && localStorage.getItem('token')) {
    global.token = localStorage.getItem('token')
  }

  const loginStatus = sessionStorage.getItem('LOGIN_STATUS') || '0';
  switch (loginStatus) {
    case '0':
      wechatAuth.redirect_uri = processUrl();
      sessionStorage.setItem('LOGIN_STATUS', 1);
      window.location.href = wechatAuth.authUrl;
      break
    case '1':
      try {
        wechatAuth.returnFromWechat(window.location.href);
        await processLogin(wechatAuth.code);

        next()
      } catch (err) {
        sessionStorage.setItem('LOGIN_STATUS', 0);
        next()
      }
      break
    case '2':
      next()
      break
    default:
      break
  }

})

export default router   // 抛出router
